import React from 'react'
import { StudentIframePage } from '../Common/StudentIframePage'

const StudentSupplementalEssay = () => {
	return <StudentIframePage activeMenu="SuplementalEssay" pageName="SupplementalEssay" linkField="supplementallink" title="Supplemental Essays" />
}

export { StudentSupplementalEssay }
